import { type SkillSummary } from "@/shared/domain/skills";

/** Mirror of the backend ``MAX_AVAILABLE_SKILLS`` cap on a session's explicit
 *  skill set. Every attached skill becomes a line in the agent's LoadSkillTool
 *  registry, so an unbounded set bloats the per-turn prompt. */
export const MAX_AVAILABLE_SKILLS = 100;

/**
 * True when this skill is eligible to be attached to an agent.
 *
 * Mirrors the backend's ``_validate_agent_available_skills`` rule: any
 * org-shared tier (``org`` or ``org-editable``) is fair game — both have
 * org-wide visibility, only their edit surface differs. Private skills are
 * rejected because they would not resolve for any other org member who
 * launches the agent.
 */
export function isAgentEligibleSkill(summary: SkillSummary): boolean {
  return (
    summary.skill.accessibility === "org" ||
    summary.skill.accessibility === "org-editable"
  );
}
